import React from 'react';
import { EnglishCCAClass3to52025 } from '../views';

const ClassAssemblyPage = () => {
    return <EnglishCCAClass3to52025/>;
  };
  
  export default ClassAssemblyPage;